import * as React from 'react';
import * as Styled from './UnitDisplay.styles';
import useUnits from '@innovyze/stylovyze/lib/hooks/useUnits';
/**
 * Display metric value with unit in the correct unit system (metric/imperial)
 */
export const UnitDisplay = ({ value, cy, invalidValue, decimalPlaces, }) => {
    const { getSystemValueFormatted } = useUnits();
    return (React.createElement(Styled.Wrapper, { "data-cy": cy }, getSystemValueFormatted(value, invalidValue, decimalPlaces)));
};
UnitDisplay.defaultProps = {};
export default UnitDisplay;
